<script>
import {
  View,
  Star,
  ChatDotRound,
  Document,
  Wallet,
  CircleClose,
  Share,
  List,
  Check,
  Edit,
  ArrowRight,
  Ticket,
  Coin,
  Setting,
  WarningFilled,
  Bell,
  Reading
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { goToLogin } from '@/utils/loginFlow'
import { isCompactViewport } from '@/utils/browser'
import { resolveProfilePhotoUrl } from '@/utils/photoUpload'
import { fetchUnreadMessageCount } from '@/utils/userHub'

export default {
  name: 'MyPage',
  components: {
    View,
    Star,
    ChatDotRound,
    Document,
    Wallet,
    CircleClose,
    Share,
    List,
    Check,
    Edit,
    ArrowRight,
    Ticket,
    Coin,
    Setting,
    WarningFilled,
    Bell,
    Reading
  },
  data() {
    return {
      compact: isCompactViewport(),
      unreadMessageCount: 0,
      todos: [],
      todoActing: '',
      stats: {
        visitedCount: 0,
        visitedmeCount: 0,
        likedCount: 0,
        likedmeCount: 0,
        mutuallikedCount: 0,
        commentCount: 0,
        commentmeCount: 0,
        listenCount: 0,
        momentsCount: 0,
        momentslikeCount: 0,
        momentsthumsupCount: 0,
        myTestsCount: 0,
        myCertsCount: 0,
        avatar: '',
        visiteCount: 0,
        testCount: 0,
        certificationCount: 0,
        blacklistCount: 0,
        blogCount: 0
      },
      vipInfo: {
        level: 0,
        expireAt: '',
        isVerified: 0
      },
      balance: 0,
      accountSections: [
        { id: 'security', name: '账号安全', icon: 'Setting', path: '/user/password', desc: '登录名与密码' },
        { id: 'recharge', name: '充值', icon: 'Wallet', path: '/recharge', desc: '余额充值' },
        { id: 'recharge-list', name: '充值记录', icon: 'List', path: '/recharge/list', desc: '历史充值单' },
        { id: 'transactions', name: '账单明细', icon: 'Document', path: '/transactions', desc: '收支流水' },
        { id: 'withdraw', name: '提现申请', icon: 'Wallet', path: '/withdraw/apply', desc: '提现至银行卡' }
      ],
      learnSections: [
        { id: 'exam', name: '测试历史', icon: 'List', path: '/exam/my-results', countKey: 'myCertsCount', desc: '已完成测评' },
        { id: 'progress', name: '学习进度', icon: 'Reading', path: '/knowledge/progress', desc: '课程掌握情况' }
      ],
      inviteReferralSections: [
        { id: 10, name: '绑定礼券', icon: 'Ticket', path: '/referral/bind-coupon', desc: '登录后补绑礼遇' },
        { id: 8, name: '我的礼券', icon: 'Ticket', path: '/referral/coupons', desc: '创建与分享' },
        { id: 9, name: '推荐收益', icon: 'Coin', path: '/referral/earnings', desc: '推荐与分润' },
        { id: 11, name: '申请合伙人', icon: 'Share', path: '/referral/partner-apply', desc: '需先实名' }
      ],
      creatorEntries: [
        { id: 'courses', name: '我创建的课程', icon: 'Edit', path: '/creator/courses', desc: '封面、审核与上下架' },
        { id: 'exams', name: '我创建的测评', icon: 'List', path: '/creator/exams', desc: '题目、审核与兑换码' },
        { id: 'blogs', name: '我创建的文章', icon: 'Document', path: '/blogs/list/my', countKey: 'blogCount', desc: '发布与审核' },
        { id: 21, name: '创作者收入', icon: 'Coin', path: '/creator/income', desc: '内容销售分账' }
      ],
      socialStats: [
        { key: 'visitedCount', label: '我访问', path: '/visite?tab=visited' },
        { key: 'visitedmeCount', label: '访问我', path: '/visite?tab=visitedme' },
        { key: 'likedCount', label: '我喜欢', path: '/like?tab=liked' },
        { key: 'likedmeCount', label: '喜欢我', path: '/like?tab=likedme' },
        { key: 'mutuallikedCount', label: '互相喜欢', path: '/like?tab=mutualliked' },
        { key: 'commentCount', label: '我评论', path: '/comments?tab=mine' },
        { key: 'commentmeCount', label: '评论我', path: '/comments?tab=received' },
        { key: 'blacklistCount', label: '黑名单', path: '/blacklist' }
      ],
      momentStats: [
        { key: 'momentsCount', label: '动态', path: '/moment' },
        { key: 'momentslikeCount', label: '获赞' },
        { key: 'momentsthumsupCount', label: '点赞' }
      ]
    }
  },
  computed: {
    isVerified() {
      return Number(this.vipInfo.isVerified) !== 0
    }
  },
  mounted() {
    this.onResize = () => {
      this.compact = isCompactViewport()
    }
    window.addEventListener('resize', this.onResize)
  },
  beforeUnmount() {
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize)
    }
  },
  created() {
    if (this.$root.isLoggedIn) {
      this.fetchUserStats()
      this.fetchUserProfile()
      this.fetchUserBalance()
      this.fetchUnread()
      this.fetchTodos()
    }
  },
  methods: {

    getUserName() {
      try {
        const user = JSON.parse(localStorage.getItem('user_info') || '{}')
        return user.nickname || user.username || '我的主页'
      } catch {
        return '我的主页'
      }
    },

    async fetchUnread() {
      try {
        this.unreadMessageCount = await fetchUnreadMessageCount()
      } catch {
        this.unreadMessageCount = 0
      }
    },

    async fetchTodos() {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/todo/list', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: '{}'
        })
        const data = await response.json()
        if (data.code === 200) {
          this.todos = data.data?.items || []
        }
      } catch (error) {
        console.error('Failed to fetch todos:', error)
      }
    },

    async actTodo(item, action) {
      if (!item?.key || this.todoActing) return
      this.todoActing = item.key
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/todo/act', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ key: item.key, action })
        })
        const data = await response.json()
        if (data.code === 200) {
          ElMessage.success(data.message || (action === 'defer' ? '已暂缓' : '已完成'))
          await this.fetchTodos()
        } else {
          ElMessage.error(data.message || '操作失败')
        }
      } catch (error) {
        console.error('Failed to update todo:', error)
        ElMessage.error('操作失败')
      } finally {
        this.todoActing = ''
      }
    },

    async fetchUserStats() {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/stats', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        const data = await response.json()
        if (data.code === 200 && data.data) {
          this.stats = {
            visitedCount: data.data.visitedCount || 0,
            visitedmeCount: data.data.visitedmeCount || 0,
            likedCount: data.data.likedCount || 0,
            likedmeCount: data.data.likedmeCount || 0,
            mutuallikedCount: data.data.mutuallikedCount || 0,
            commentCount: data.data.commentCount || 0,
            commentmeCount: data.data.commentmeCount || 0,
            listenCount: data.data.listenCount || 0,
            momentsCount: data.data.momentsCount || 0,
            momentslikeCount: data.data.momentslikeCount || 0,
            momentsthumsupCount: data.data.momentsthumsupCount || 0,
            myTestsCount: data.data.myTestsCount || 0,
            myCertsCount: data.data.myCertsCount || 0,
            avatar: resolveProfilePhotoUrl(data.data.avatar, data.data.photo) || '',
            visiteCount: data.data.visiteCount || 0,
            testCount: data.data.testCount || 0,
            certificationCount: data.data.certificationCount || 0,
            blacklistCount: data.data.blacklistCount || 0,
            blogCount: data.data.blogCount || 0
          }
          this.fetchExtraSectionCounts()
        } else if (data.code === 401) {
          ElMessage.error(data.message)
          goToLogin(this.$router, '/my')
        } else {
          ElMessage.error(data.message)
        }
      } catch (error) {
        console.error('Failed to fetch user stats:', error)
      }
    },

    async fetchUserProfile() {
      try {
        const token = localStorage.getItem('jwt_token')
        const uuid = localStorage.getItem('uuid')
        const response = await fetch('/api/v1/user/myprofile/get', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ uuid })
        })

        const data = await response.json()
        if (data.code === 200 && data.data) {
          this.vipInfo = {
            level: data.data.vip_level || 0,
            expireAt: data.data.vip_expire_at || '',
            isVerified: data.data.isVerified || 0
          }
        }
      } catch (error) {
        console.error('Failed to fetch user profile:', error)
      }
    },

    async fetchUserBalance() {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/balance', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        const data = await response.json()
        if (data.code === 200 && data.data && data.data.length > 0) {
          this.balance = (data.data[0].balance / 100).toFixed(2)
        }
      } catch (error) {
        console.error('Failed to fetch user balance:', error)
      }
    },

    async fetchExtraSectionCounts() {
      const token = localStorage.getItem('jwt_token')
      if (!token) return
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
      try {
        const [blackRes, blogRes] = await Promise.all([
          fetch('/api/v1/user/blacklist', {
            method: 'POST',
            headers,
            body: JSON.stringify({ page: 1, pageSize: 1 })
          }),
          fetch('/api/v1/blog/list/my', {
            method: 'POST',
            headers,
            body: JSON.stringify({ page: 1, pageSize: 1 })
          })
        ])
        const blackData = await blackRes.json()
        if (blackData.code === 200) {
          this.stats.blacklistCount = blackData.data?.total || 0
        }
        const blogData = await blogRes.json()
        if (blogData.code === 200) {
          this.stats.blogCount = blogData.data?.total || 0
        }
      } catch (e) {
        console.error('Failed to fetch extra section counts:', e)
      }
    },

    sectionCount(section) {
      if (!section.countKey) return 0
      return Number(this.stats[section.countKey] || 0)
    },

    goSocialStat(item) {
      if (item?.path) this.$router.push(item.path)
    },

    navigateToSection(section) {
      if (section?.path) this.$router.push(section.path)
    },

    navigateToRealNameVerification() {
      this.$router.push('/real-name-verification')
    },

    navigateToWithdraw() {
      this.$router.push('/withdraw/apply')
    },

    navigateToRecharge() {
      this.$router.push('/recharge')
    },

    navigateToProfile() {
      this.$router.push('/user/info')
    }
  }
}
</script>

<template>
  <div class="my-page" :class="{ 'my-page--compact': compact }">
    <!-- 头像 + 实名 + 余额 -->
    <section class="panel profile-panel">
      <div class="profile-row">
        <button type="button" class="avatar-block" @click="navigateToProfile">
          <img
            :src="stats.avatar || 'https://picsum.photos/100/100?random=1'"
            alt="头像"
            class="avatar"
          >
          <span class="avatar-edit">资料</span>
        </button>

        <div class="profile-main">
          <div class="name-row">
            <h2>{{ getUserName() }}</h2>
            <el-tag v-if="vipInfo.level > 0" type="warning" size="small" effect="plain">VIP {{ vipInfo.level }}</el-tag>
          </div>

          <div class="verify-row">
            <template v-if="isVerified">
              <el-tag type="success" size="small" effect="light">
                <el-icon><Check /></el-icon>
                已实名
              </el-tag>
              <button type="button" class="text-link" @click="navigateToRealNameVerification">查看认证</button>
            </template>
            <template v-else>
              <el-tag type="warning" size="small" effect="light">未实名</el-tag>
              <el-button type="warning" size="small" @click="navigateToRealNameVerification">申请实名</el-button>
            </template>
          </div>

          <div class="money-row">
            <button type="button" class="money-chip" @click="navigateToWithdraw">
              <el-icon><Wallet /></el-icon>
              <span>余额 ¥{{ balance }}</span>
            </button>
            <el-button type="primary" size="small" plain @click="navigateToRecharge">充值</el-button>
            <el-button type="warning" size="small" plain @click="navigateToWithdraw">提现</el-button>
          </div>
        </div>
      </div>
    </section>

    <!-- 待办 -->
    <section v-if="todos.length" class="panel urgent-panel">
      <h3 class="panel-title">
        <el-icon class="panel-title__icon panel-title__icon--warn"><WarningFilled /></el-icon>
        待办事项
        <span class="panel-title__count">{{ todos.length }}</span>
      </h3>
      <div class="urgent-list">
        <div
          v-for="item in todos"
          :key="item.key"
          class="todo-row"
          :class="`urgent-item--${item.tone}`"
        >
          <button type="button" class="todo-row__main" @click="navigateToSection(item)">
            <el-icon class="urgent-item__icon">
              <Bell v-if="item.key === 'unread_messages'" />
              <Check v-else-if="item.key === 'realname'" />
              <Setting v-else />
            </el-icon>
            <span class="urgent-item__body">
              <span class="urgent-item__title">{{ item.title }}</span>
              <span class="urgent-item__desc">{{ item.desc }}</span>
            </span>
            <el-badge v-if="item.badge" :value="item.badge" :max="99" class="urgent-item__badge" />
            <el-icon class="urgent-item__arrow"><ArrowRight /></el-icon>
          </button>
          <div class="todo-row__actions">
            <button type="button" class="text-link" :disabled="todoActing === item.key" @click="actTodo(item, 'defer')">暂缓</button>
            <button type="button" class="text-link" :disabled="todoActing === item.key" @click="actTodo(item, 'done')">完成</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 互动统计：站内信置顶 + 一行 8 格 -->
    <section class="panel stats-panel">
      <h3 class="panel-title">社交互动</h3>
      <button
        type="button"
        class="msg-entry"
        @click="navigateToSection({ path: '/user/messages' })"
      >
        <el-icon class="msg-entry__icon"><ChatDotRound /></el-icon>
        <span class="msg-entry__name">站内信</span>
        <span class="msg-entry__desc">审核、喜欢、分润等通知</span>
        <el-badge
          v-if="unreadMessageCount"
          :value="unreadMessageCount"
          :max="99"
          class="msg-entry__badge"
        />
        <el-icon class="msg-entry__arrow"><ArrowRight /></el-icon>
      </button>
      <div class="stats-grid stats-grid--social">
        <button
          v-for="item in socialStats"
          :key="item.key"
          type="button"
          class="stat-item"
          @click="goSocialStat(item)"
        >
          <span class="count">{{ stats[item.key] }}</span>
          <span class="label">{{ item.label }}</span>
        </button>
      </div>

      <h3 class="panel-title panel-title--sub">动态</h3>
      <div class="stats-grid stats-grid--moments">
        <button
          v-for="item in momentStats"
          :key="item.key"
          type="button"
          class="stat-item"
          @click="goSocialStat(item)"
        >
          <span class="count">{{ stats[item.key] }}</span>
          <span class="label">{{ item.label }}</span>
        </button>
      </div>
    </section>

    <!-- 学习与测试 -->
    <section class="panel">
      <h3 class="panel-title">学习与测试</h3>
      <div class="link-list">
        <button
          v-for="section in learnSections"
          :key="section.id"
          type="button"
          class="link-item"
          @click="navigateToSection(section)"
        >
          <el-icon class="link-item__icon"><component :is="section.icon" /></el-icon>
          <span class="link-item__name">{{ section.name }}</span>
          <span v-if="sectionCount(section) > 0" class="link-item__count">{{ sectionCount(section) }}</span>
          <span v-else class="link-item__desc">{{ section.desc }}</span>
          <el-icon class="link-item__arrow"><ArrowRight /></el-icon>
        </button>
      </div>
    </section>

    <!-- 账户与资金 -->
    <section class="panel">
      <h3 class="panel-title">账户与资金</h3>
      <div class="link-list">
        <button
          v-for="section in accountSections"
          :key="section.id"
          type="button"
          class="link-item"
          @click="navigateToSection(section)"
        >
          <el-icon class="link-item__icon"><component :is="section.icon" /></el-icon>
          <span class="link-item__name">{{ section.name }}</span>
          <span class="link-item__desc">{{ section.desc }}</span>
          <el-icon class="link-item__arrow"><ArrowRight /></el-icon>
        </button>
      </div>
    </section>

    <!-- 礼券与推荐 -->
    <section class="panel">
      <h3 class="panel-title">礼券与推荐</h3>
      <div class="link-list">
        <button
          v-for="section in inviteReferralSections"
          :key="section.id"
          type="button"
          class="link-item"
          @click="navigateToSection(section)"
        >
          <el-icon class="link-item__icon"><component :is="section.icon" /></el-icon>
          <span class="link-item__name">{{ section.name }}</span>
          <span class="link-item__desc">{{ section.desc }}</span>
          <el-icon class="link-item__arrow"><ArrowRight /></el-icon>
        </button>
      </div>
    </section>

    <!-- 创作 -->
    <section class="panel">
      <h3 class="panel-title">创作中心</h3>
      <div class="link-list">
        <button
          v-for="section in creatorEntries"
          :key="section.id"
          type="button"
          class="link-item"
          @click="navigateToSection(section)"
        >
          <el-icon class="link-item__icon"><component :is="section.icon" /></el-icon>
          <span class="link-item__name">{{ section.name }}</span>
          <span v-if="sectionCount(section) > 0" class="link-item__count">{{ sectionCount(section) }}</span>
          <span v-else class="link-item__desc">{{ section.desc }}</span>
          <el-icon class="link-item__arrow"><ArrowRight /></el-icon>
        </button>
      </div>
    </section>
  </div>
</template>

<style scoped>
.my-page {
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
  padding: 12px 16px 24px;
  box-sizing: border-box;
}

.my-page--compact {
  max-width: none;
  padding: 0;
  background: #f5f6f8;
  min-height: calc(100vh - 52px);
}

.panel {
  background: #fff;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.my-page--compact .panel {
  margin: 0 0 8px;
  border-radius: 0;
  box-shadow: none;
  border-bottom: 1px solid #ebeef5;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.panel-title--sub {
  margin-top: 12px;
  font-size: 13px;
  color: #606266;
}

.panel-title__icon--warn {
  color: #e6a23c;
}

.panel-title__count {
  margin-left: 2px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #f56c6c;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  font-weight: 600;
}

/* —— 头像区 —— */
.profile-row {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.avatar-block {
  position: relative;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.avatar {
  display: block;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
}

.my-page--compact .avatar {
  width: 64px;
  height: 64px;
}

.avatar-edit {
  position: absolute;
  left: 50%;
  bottom: -2px;
  transform: translateX(-50%);
  padding: 0 6px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 10px;
  line-height: 16px;
}

.profile-main {
  flex: 1;
  min-width: 0;
}

.name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.name-row h2 {
  margin: 0;
  font-size: 18px;
  line-height: 1.2;
  color: #303133;
}

.verify-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.verify-row .el-tag {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.text-link {
  border: none;
  background: transparent;
  color: #409eff;
  font-size: 13px;
  padding: 0;
  cursor: pointer;
}

.money-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.money-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: none;
  border-radius: 16px;
  background: #fdf6ec;
  color: #b88230;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.money-chip .el-icon {
  font-size: 14px;
}

/* —— 待处理 —— */
.urgent-panel {
  border: 1px solid #f5dab1;
  background: linear-gradient(180deg, #fffbf5 0%, #fff 60%);
}

.my-page--compact .urgent-panel {
  border-left: none;
  border-right: none;
  border-top: none;
}

.urgent-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.todo-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  border: 1px solid #f0f2f5;
  border-radius: 8px;
  background: #fff;
}

.todo-row__main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
  padding: 10px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.todo-row__actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 8px 10px 8px 0;
  flex-shrink: 0;
}

.todo-row__actions .text-link:disabled {
  opacity: 0.5;
  cursor: default;
}

.urgent-item--warning {
  border-color: #f5dab1;
}

.urgent-item--danger {
  border-color: #fbc4c4;
}

.urgent-item--primary {
  border-color: #d9ecff;
}

.urgent-item__icon {
  flex-shrink: 0;
  font-size: 18px;
  color: #e6a23c;
}

.urgent-item--danger .urgent-item__icon {
  color: #f56c6c;
}

.urgent-item--primary .urgent-item__icon {
  color: #409eff;
}

.urgent-item__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.urgent-item__title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.urgent-item__desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.35;
}

.urgent-item__arrow {
  color: #c0c4cc;
  font-size: 14px;
}

.urgent-item__badge {
  margin-right: 2px;
}

/* —— 站内信入口 —— */
.msg-entry {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 10px;
  padding: 8px 10px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #f7f8fa;
  cursor: pointer;
  text-align: left;
}

.msg-entry:hover {
  background: #eef5ff;
  border-color: #c6e2ff;
}

.msg-entry__icon {
  font-size: 18px;
  color: #409eff;
  flex-shrink: 0;
}

.msg-entry__name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  flex-shrink: 0;
}

.msg-entry__desc {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.msg-entry__badge {
  margin-right: 2px;
}

.msg-entry__arrow {
  font-size: 14px;
  color: #c0c4cc;
  flex-shrink: 0;
}

/* —— 统计 —— */
.stats-grid {
  display: grid;
  gap: 4px;
}

.stats-grid--social {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.stats-grid--moments {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  padding: 6px 2px;
  border: none;
  border-radius: 6px;
  background: #f7f8fa;
  cursor: pointer;
  min-width: 0;
}

.stat-item:hover {
  background: #eef5ff;
}

.count {
  font-size: 14px;
  font-weight: 700;
  color: #303133;
  line-height: 1.15;
}

.label {
  font-size: 10px;
  color: #909399;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* —— 功能列表 —— */
.link-list {
  display: flex;
  flex-direction: column;
}

.link-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 11px 2px;
  border: none;
  border-bottom: 1px solid #f0f2f5;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.link-item:last-child {
  border-bottom: none;
  padding-bottom: 2px;
}

.link-item:first-child {
  padding-top: 2px;
}

.link-item:active {
  background: #f7f8fa;
}

.link-item__icon {
  font-size: 18px;
  color: #409eff;
  flex-shrink: 0;
}

.link-item__name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.link-item__desc {
  flex: 1;
  font-size: 12px;
  color: #909399;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link-item__count {
  font-size: 13px;
  color: #909399;
  margin-left: auto;
}

.link-item__badge {
  margin-left: auto;
}

.link-item__arrow {
  font-size: 14px;
  color: #c0c4cc;
  flex-shrink: 0;
}

@media screen and (max-width: 560px) {
  .stats-grid--social {
    grid-template-columns: repeat(8, minmax(0, 1fr));
    gap: 3px;
  }

  .stat-item {
    padding: 5px 1px;
  }

  .count {
    font-size: 13px;
  }

  .label {
    font-size: 9px;
  }

  .msg-entry__desc {
    display: none;
  }

  .link-item__desc {
    display: none;
  }

  .money-row .el-button {
    padding: 5px 10px;
  }
}
</style>
